export default __webpack_public_path__ + "static/media/케이뱅크.7a2f22b5.svg";